import React, { ReactNode, useEffect } from "react";
import CustomHeader from "../../header";
import { Layout } from "antd";
import CustomSidebar from "../../sidebar";
import { Outlet } from "react-router-dom";
import { getUserIdentity } from "../../../services/authService";
import { ServerError } from "components/shared/errorNotification/errorNotification";
import { useAppDispatch } from "hooks";
import { SelfUser } from "redux/features/authSlice";
interface Props {
  children?: ReactNode;
}
const PrivateLayout: React.FC<Props> = () => {
  const dispatch = useAppDispatch();

  const onLoad = async () => {
    try {
      const { data } = await getUserIdentity();
      if (data.success) {
        dispatch(SelfUser(data.data));
      }
    } catch {
      ServerError();
    }
  };

  useEffect(() => {
    onLoad();
  }, []);
  const { Content } = Layout;
  return (
    <>
      <div>
        <main className="app">
          <Layout>
            <CustomSidebar />
            <Layout className="site-layout">
              <CustomHeader />
              <Content className="site-layout-background">
                <Outlet />
              </Content>
            </Layout>
          </Layout>
        </main>
      </div>
    </>
  );
};

export default PrivateLayout;
